<template>
  <div>
    <Loading :visible="isLoadingPop"></Loading>
    <div class="wrap coaching-journal-write-wrap">
      <div class="top-header">
        <incBack></incBack>
        <h3>코칭일지 수정하기</h3>
      </div>
      <div class="body-wrap">
        <incCourse :sessionIdx="sessionIdx"></incCourse>

        <div class="journal">
          <p class="info">*녹색 항목은 고객에게 노출되는 항목이니, 유의하여 작성해 주세요.</p>
          <div class="journal-form">
            <p>대면 장소<span class="txt-red"> *</span></p>
            <input type="text" placeholder="대면 장소를 입력해 주세요." v-model="input.coarchingnoteArea" />
          </div>
          <div class="journal-form">
            <p class="point">본 세션 코칭 주제<span class="txt-red"> *</span></p>
            <textarea
              placeholder="이번 세션에서 다루어진 주제 또는 사례를 기록해주세요."
              v-model="input.coarchingnoteSession"
            ></textarea>
          </div>
          <div class="journal-form">
            <p style="margin-bottom: 15px">목표 달성 날짜<span class="txt-red"> *</span></p>
            <DatePicker
              is-expanded
              style="border: none"
              locale="en"
              color="green"
              v-model="input.coarchingnoteFinishdate"
              :min-date="new Date()"
            ></DatePicker>
          </div>
          <div class="journal-form">
            <p>코칭 내용<span class="txt-red"> *</span></p>
            <textarea
              placeholder="사용된 코칭 기법 및 코칭 내용을 기록해주세요. (해당 항목은 고객에게 노출되지 않습니다.)"
              v-model="input.coarchingnoteContent1"
            ></textarea>
          </div>
          <div class="journal-form">
            <p class="point">과제 및 차후 계획<span class="txt-red"> *</span></p>
            <textarea
              placeholder="고객에게 부여한 과제 및 차후 진행 계획에 대해 기록해 주세요."
              v-model="input.coarchingnoteContent2"
            ></textarea>
          </div>
          <div class="journal-form">
            <p class="point">코치's Comment<span class="txt-red"> *</span></p>
            <textarea placeholder="고객에게 전할 코멘트를 입력해 주세요." v-model="input.coarchingnoteComment"></textarea>
          </div>
          <div class="journal-form">
            <p>메모</p>
            <textarea
              placeholder="기타 메모 등을 남겨 주세요. (해당 항목은 고객에게 노출되지 않습니다.)"
              v-model="input.coarchingnoteMemo"
            ></textarea>
          </div>
        </div>

        <div class="bnb-btn">
          <button class="active" @click="save()">저장하기</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import incCourse from "@/components/inc/inc_course.vue";
import incBack from "@/components/inc/inc_back.vue";
import DatePicker from "v-calendar/lib/components/date-picker.umd";
import { EmptyCheck } from "@/utils/validation.js";
import dayjs from "dayjs";
import Loading from "@/components/inc/inc_loading.vue";
export default {
  name: "coaching_journal_write",
  props: {
    sessionIdx: {
      type: [Number, String],
      default: 0,
    },
    courseIdx: {
      type: [Number, String],
      default: 0,
    },
  },
  data: () => ({
    jouranl: {},
    input: {
      coarchingnoteArea: "",
      coarchingnoteSession: "",
      coarchingnoteFinishdate: "",
      coarchingnoteContent1: "",
      coarchingnoteContent2: "",
      coarchingnoteComment: "",
      coarchingnoteMemo: "",
      sessionIdx: 0,
      courseIdx: 0,
      userIdx: 0,
    },
    isLoadingPop: false,
  }),
  components: {
    DatePicker,
    incBack,
    incCourse,
    Loading,
  },
  mounted() {
    this.getJournal();
  },
  methods: {
    getJournal() {
      let params = {
        sessionIdx: this.sessionIdx,
      };
      this.axios
        .get("/front/coarching/complete/note/detail", { params })
        .then((res) => {
          if (res.data.success) {
            // this.jouranl = res.data.contentinfo;
            this.input = res.data.contentinfo.coarchingNoteDetail;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    save() {
      if (confirm("코칭일지를 저장 하시겠습니까?")) {
        this.input.coarchingnoteFinishdate = dayjs(this.input.coarchingnoteFinishdate).format("YYYY-MM-DD");
        if (!EmptyCheck(this.input.coarchingnoteArea, "대면 장소를")) {
          return false;
        }
        if (!EmptyCheck(this.input.coarchingnoteSession, "본 세션 코칭 주제를")) {
          return false;
        }
        if (!EmptyCheck(this.input.coarchingnoteFinishdate, "목표 달성 날짜를")) {
          return false;
        }
        if (!EmptyCheck(this.input.coarchingnoteContent1, "코칭 내용을")) {
          return false;
        }
        if (!EmptyCheck(this.input.coarchingnoteContent2, "과제 및 차후 계획을")) {
          return false;
        }
        if (!EmptyCheck(this.input.coarchingnoteComment, "코치's Comment를")) {
          return false;
        }

        this.input.sessionIdx = this.sessionIdx;
        this.input.courseIdx = this.courseIdx;
        this.isLoadingPop = true;
        let form = new FormData();
        for (const [key, value] of Object.entries(this.input)) {
          form.append(key, value);
        }
        this.axios
          .post("/front/coarching/complete/note/edit", form)
          .then((res) => {
            if (res.data.success) {
              this.isLoadingPop = false;
              this.$router.replace({ name: "coaching_journal_view", params: { sessionIdx: this.sessionIdx } });
            } else {
              alert(res.data.message);
              this.isLoadingPop = false;
            }
          })
          .catch((err) => {
            this.isLoadingPop = false;
            console.log(err);
          });
        // this.input);
        // this.$router.push("coaching_journal_view");
      }
    },
  },
};
</script>
